<div class="d-flex flex-column sp-between h-100">
  <div>
    <app-header></app-header>
  </div>
  <div class="content-main">
    <router-outlet></router-outlet>
  </div>
  <div>
    <app-footer></app-footer>
  </div>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-atom" [fullScreen]="true">
</ngx-spinner>